import React, { useState, useEffect } from 'react';
import { AppTheme, ContractorNew } from '../types';

interface ContractorNewFormProps {
  theme: AppTheme;
  onSubmit: (data: Omit<ContractorNew, 'id' | 'created_at' | 'is_deleted'>) => void;
  onCancel: () => void;
  initialData?: ContractorNew;
}

export const ContractorNewForm: React.FC<ContractorNewFormProps> = ({
  theme,
  onSubmit,
  onCancel,
  initialData
}) => {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    address: ''
  });

  useEffect(() => {
    if (initialData) {
      setFormData({
        name: initialData.name || '',
        phone: initialData.phone || '',
        address: initialData.address || ''
      });
    }
  }, [initialData]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit(formData);
  };

  const inputStyle: React.CSSProperties = {
    width: '100%',
    padding: '8px',
    border: `1px solid ${theme.colors.border}`,
    borderRadius: '4px',
    backgroundColor: theme.colors.background,
    color: theme.colors.text,
    fontSize: '14px',
  };

  const labelStyle: React.CSSProperties = {
    display: 'block',
    marginBottom: '4px',
    fontWeight: 'bold',
    color: theme.colors.text,
  };

  const buttonStyle: React.CSSProperties = {
    padding: '8px 16px',
    margin: '0 4px',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '14px',
  };

  return (
    <form onSubmit={handleSubmit} style={{ padding: '16px' }}>
      <div style={{ marginBottom: '16px' }}>
        <label style={labelStyle}>Название:</label>
        <input
          type="text"
          value={formData.name}
          onChange={(e) => setFormData({ ...formData, name: e.target.value })}
          style={inputStyle}
          required
        />
      </div>

      <div style={{ marginBottom: '16px' }}>
        <label style={labelStyle}>Телефон:</label>
        <input
          type="text"
          value={formData.phone}
          onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
          style={inputStyle}
          required
        />
      </div>

      <div style={{ marginBottom: '16px' }}>
        <label style={labelStyle}>Адрес:</label>
        <textarea
          value={formData.address}
          onChange={(e) => setFormData({ ...formData, address: e.target.value })}
          style={{ ...inputStyle, minHeight: '80px', resize: 'vertical' }}
          required
        />
      </div>

      <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '20px' }}>
        <button
          type="button"
          onClick={onCancel}
          style={{
            ...buttonStyle,
            backgroundColor: theme.colors.border,
            color: theme.colors.text,
          }}
        >
          Отмена
        </button>
        <button
          type="submit"
          style={{
            ...buttonStyle,
            backgroundColor: theme.colors.primary,
            color: 'white',
          }}
        >
          {initialData ? 'Сохранить' : 'Добавить'}
        </button>
      </div>
    </form>
  );
};